import PermissionChecker from 'src/modules/auth/permissionChecker';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import config from 'src/config';
import { tenantSubdomain } from 'src/modules/tenant/tenantSubdomain';

function PublicRouteWithLoginOption({
  component: Component,
  currentTenant,
  currentUser,
  permissionRequired,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={(props) => {           
        const permissionChecker = new PermissionChecker(
          currentTenant,
          currentUser,
        );
        if(permissionChecker.isAuthenticated) {
          if (!permissionChecker.isEmailVerified) {
            return <Redirect to="/auth/email-unverified" />;
          }  
          if (
            ['multi', 'multi-with-subdomain'].includes(
              config.tenantMode,
            ) &&
            !tenantSubdomain.isSubdomain
          ) {
            if (permissionChecker.isEmptyTenant) {
              return <Redirect to="/auth/tenant" />;
            }
          } else {
            if (permissionChecker.isEmptyPermissions) {
              return (
                <Redirect to="/auth/empty-permissions" />
              );
            }
          }          
          if (!permissionChecker.match(permissionRequired)) {
            return <Redirect to="/403" />;
          }
        }
        return <Component {...props} />;
      }}
    />
  );
}

export default PublicRouteWithLoginOption;
